






































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { SalonHistory } from "@/models/salon_history";
import SystemConst from "@/config/const";
import SalonFavoriteService from "@/services/SalonFavoriteService";

@Component
export default class SalonTipComponent extends Vue {
  @Prop({ default: {} })
  pSalonHistory!: any;
  salonType = SystemConst.SALON_TYPE;

  @Prop({ default: false })
  pUnFavMode!: boolean;

  faved = false;

  get getGenreLabel(): string {
    const genreId = this.pSalonHistory.salon_genre + "_genre";
    for (const genre of this.salonType) {
      if (genreId == genre.value) {
        return genre.label;
      }
    }
    return "";
  }

  get station(): string {
    let stationStr = "最寄駅なし";
    if (this.pSalonHistory.nearest_station_1 != "") {
      stationStr =
        this.pSalonHistory.nearest_station_1 === null
          ? "テキスト"
          : this.pSalonHistory.nearest_station_1;
    }
    if (this.pSalonHistory.nearest_station_2 != "") {
      stationStr +=
        this.pSalonHistory.nearest_station_2 === null
          ? "、" + "テキスト"
          : "、" + this.pSalonHistory.nearest_station_2;
    }
    if (this.pSalonHistory.nearest_station_3 != "") {
      stationStr +=
        this.pSalonHistory.nearest_station_3 === null
          ? "、" + "テキスト "
          : "、" + this.pSalonHistory.nearest_station_3;
    }
    return stationStr;
  }

  googleMapUrl(address: string): string {
    const query = encodeURI(address);
    const google = "https://maps.google.co.jp/maps?q=";
    const url = google + query;
    return url;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get parent(): any {
    return this.$parent;
  }

  get isLogin(): boolean {
    return this.$store.getters.isLogin;
  }

  async fav() {
    if (!this.isLogin) return;
    if (this.pUnFavMode) {
      this.parent.unFav(this.pSalonHistory.id);
      this.faved = false;
      await SalonFavoriteService.deleteSalon(this.pSalonHistory.id);
    } else {
      this.faved = true;
      await SalonFavoriteService.createSalon({
        salon_id: this.pSalonHistory.id,
      });
    }
  }

  async unFav() {
    if (!this.isLogin) return;
    if (this.pUnFavMode) {
      this.parent.unFav(this.pSalonHistory.id);
    }
    this.faved = false;
    await SalonFavoriteService.deleteSalon(this.pSalonHistory.id);
  }

  async favedStatus() {
    if (!this.isLogin) return;
    if (this.pUnFavMode) {
      this.faved = true;
      return;
    }

    const response = await SalonFavoriteService.getSalon(this.pSalonHistory.id);
    if (response.data.salon_favorite) {
      this.faved = true;
    } else {
      this.faved = false;
    }
  }

  public created() {
    this.favedStatus();
  }

  @Watch("pSalonHistory", { deep: true })
  onPSalonHistoryChanged() {
    this.favedStatus();
  }
}
